import { render, staticRenderFns } from "./PostBatch.vue?vue&type=template&id=54b2dd7a&"
import script from "./PostBatch.vue?vue&type=script&lang=js&"
export * from "./PostBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3043685859/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b2dd7a')) {
      api.createRecord('54b2dd7a', component.options)
    } else {
      api.reload('54b2dd7a', component.options)
    }
    module.hot.accept("./PostBatch.vue?vue&type=template&id=54b2dd7a&", function () {
      api.rerender('54b2dd7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PostBatch.vue"
export default component.exports